(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDetailController', ObservedDataDetailController);

    ObservedDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ObservedData'];

    function ObservedDataDetailController($scope, $rootScope, $stateParams, previousState, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:observedDataUpdate', function(event, result) {
            vm.observedData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
